(function initBackInStockNotifications() {
  if (window.pbsBackInStockInitialized) return;
  window.pbsBackInStockInitialized = true;

  function getCurrentVariantId(button, formId) {
    if (formId) {
      const productForm = document.getElementById(formId);
      const variantInput = productForm?.querySelector('input[name="id"]');
      if (variantInput?.value) return variantInput.value;
    }

    const productSection = button.closest('.js-product');
    const fallbackVariantInput = productSection?.querySelector('form .js-product-form input[name="id"]');
    return fallbackVariantInput?.value || '';
  }

  function setButtonLoading(button, isLoading) {
    if (isLoading) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('is-loading');
      return;
    }

    button.classList.remove('is-loading');
    button.disabled = false;
    button.removeAttribute('aria-disabled');
  }

  function setButtonError(button, errorLabel) {
    setButtonLoading(button, false);
    button.textContent = errorLabel;
  }

  function setButtonSuccess(button, successLabel) {
    button.classList.remove('is-loading');
    button.classList.remove('btn--primary');
    button.classList.add('btn--secondary');
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.textContent = successLabel;
  }

  async function parseKlaviyoError(response) {
    try {
      const responseJson = await response.json();
      const errors = responseJson?.errors;
      if (Array.isArray(errors) && errors.length) {
        return errors.map((err) => err?.detail || err?.title).filter(Boolean).join(' | ');
      }
    } catch (e) {
      // Ignore non-JSON response body.
    }

    return `Subscription failed with status ${response.status}`;
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-back-in-stock-submit]');
    if (!button) return;

    event.preventDefault();
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const apiKey = button.dataset.publicApiKey?.trim();
    const formId = button.dataset.productFormId;
    const successLabel = button.dataset.successLabel || 'Successfully subscribed';
    const errorLabel = button.dataset.errorLabel || 'Error while subscribing to this notification.';
    const modal = button.closest('modal-dialog');
    const emailInput = modal?.querySelector('input[type="email"]');
    const email = emailInput?.value?.trim();
    const variantId = getCurrentVariantId(button, formId)?.trim();

    if (!apiKey || !email || !variantId) {
      setButtonError(button, errorLabel);
      return;
    }

    setButtonLoading(button, true);

    const requestPayload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email
              }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`
            }
          }
        }
      }
    };

    try {
      const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(apiKey)}`, {
        method: 'POST',
        headers: {
          revision: '2026-01-15',
          Accept: 'application/vnd.api+json',
          'Content-Type': 'application/vnd.api+json'
        },
        body: JSON.stringify(requestPayload)
      });

      if (!response.ok) throw new Error(await parseKlaviyoError(response));
      setButtonSuccess(button, successLabel);
    } catch (error) {
      console.error(error); // eslint-disable-line no-console
      setButtonError(button, errorLabel);
    }
  });
})();
